import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.t48_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.u48_1 = LinkedHashMap().bc();
      }
      v48() {
        return this.u48_1;
      }
      v41() {
        // Inline function 'kotlin.apply' call
        this.t48_1.v41();
        return this;
      }
      w41() {
        // Inline function 'kotlin.apply' call
        this.t48_1.w41();
        return this;
      }
      q41() {
        // Inline function 'kotlin.apply' call
        this.t48_1.q41();
        return this;
      }
      r41() {
        // Inline function 'kotlin.apply' call
        this.t48_1.r41();
        return this;
      }
      s48(name) {
        // Inline function 'kotlin.apply' call
        this.t48_1.s48(name);
        return this;
      }
      c42(value) {
        // Inline function 'kotlin.apply' call
        this.t48_1.c42(value);
        return this;
      }
      m42(value) {
        // Inline function 'kotlin.apply' call
        this.t48_1.m42(value);
        return this;
      }
      h42(value) {
        // Inline function 'kotlin.apply' call
        this.t48_1.h42(value);
        return this;
      }
      e42(value) {
        // Inline function 'kotlin.apply' call
        this.t48_1.e42(value);
        return this;
      }
      k42(value) {
        // Inline function 'kotlin.apply' call
        this.t48_1.k42(value);
        return this;
      }
      i4b(value) {
        // Inline function 'kotlin.apply' call
        this.t48_1.i4b(value);
        return this;
      }
      r42(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.u48_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.t48_1.x4a();
        tmp0.x4(key, value);
        this.t48_1.v40();
        return this;
      }
      v40() {
        // Inline function 'kotlin.apply' call
        this.t48_1.v40();
        return this;
      }
      x4a() {
        return this.t48_1.x4a();
      }
      l6() {
        this.t48_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
